// Message type constants
const AGENT_MESSAGE_TYPE = 'agent';
const FLOW_END_TYPE = 'workflow_end';
const INPUT_REQUEST_TYPE = 'request';
const TOOL_MESSAGE_TYPE = 'tool';
const USER_MESSAGE_TYPE = 'user';

// Array of all valid message types for validation
const VALID_MESSAGE_TYPES = [AGENT_MESSAGE_TYPE, FLOW_END_TYPE, INPUT_REQUEST_TYPE, TOOL_MESSAGE_TYPE, USER_MESSAGE_TYPE];

export { AGENT_MESSAGE_TYPE, FLOW_END_TYPE, INPUT_REQUEST_TYPE, TOOL_MESSAGE_TYPE, USER_MESSAGE_TYPE, VALID_MESSAGE_TYPES };
